/**
 * Format a phone number while preserving international format
 * @param {string} phone - The phone number to format
 * @returns {string} - The formatted phone number
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';

  // Remove all non-digit characters except + for international prefix
  const cleaned = phone.replace(/[^\d+]/g, '');

  // If empty or just a plus sign, return as is
  if (!cleaned || cleaned === '+') {
    return cleaned;
  }

  // Check for US format (with or without +1 prefix)
  const usMatch = cleaned.replace(/^\+1/, '').match(/^(\d{3})(\d{3})(\d{4})$/);
  if (usMatch) {
    const formatted = `(${usMatch[1]}) ${usMatch[2]}-${usMatch[3]}`;
    return cleaned.startsWith('+1') ? `+1 ${formatted}` : formatted;
  }

  // Handle other international numbers
  if (cleaned.startsWith('+')) {
    let countryCode;
    let rest;
    
    if (cleaned.startsWith('+420')) {
      countryCode = '+420';
      rest = cleaned.slice(4);
    } else if (cleaned.startsWith('+44')) {
      countryCode = '+44';
      rest = cleaned.slice(3);
    } else {
      // For unknown country codes, take up to 3 digits
      const match = cleaned.match(/^\+(\d{1,3})/);
      if (!match) return cleaned;
      countryCode = match[0];
      rest = cleaned.slice(countryCode.length);
    }

    // If rest is empty, return just the country code
    if (!rest) return countryCode;

    // Split remaining digits into groups of 3
    const digits = rest.match(/\d{1,3}/g) || [];
    
    // Join country code and groups with appropriate spacing
    return `${countryCode} ${digits.join('-')}`;
  }

  // If no pattern matches, return the cleaned number
  return cleaned;
};
